import React from 'react';
import { cn } from '../utils';

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
  spinnerClassName?: string;
  containerClassName?: string;
}

const Loader: React.FC<LoaderProps> = ({
  message,
  fullScreen = false,
  spinnerClassName = '',
  containerClassName = '',
}) => {
  const containerClasses = fullScreen
    ? 'fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50 ' + containerClassName
    : 'flex items-center justify-center w-full h-full ' + containerClassName;

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center">
        <div
          className={cn(
            'w-8 h-8 border-[3.1px] border-gray-100 border-t-gray-400 rounded-full animate-spin',
            spinnerClassName
          )}
        ></div>
        {message && (
          <p className="mt-4 text-sm text-gray-600 font-medium">{message}</p>
        )}
      </div>
    </div>
  );
};

export default Loader;
